import axios from 'axios';
import Api from '../api/ApiUrl';

const API_URL = `${Api}/api/v1`;
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin',
      dashboard:1
  },
};
const UserService = {
  registerUser: async (userData) => {
    const formData = new FormData();
    for (const key in userData) {
      if (key === 'idImage') {
        formData.append(key, userData[key][0]); // Append the file object correctly
      } else {
        formData.append(key, userData[key]);
      }
    }
    const response = await axios.post(`${API_URL}/auth/register`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      role: 'admin'

      },
    });
    return response.data;
  },
  verifyOTP: async (userId, otp) => {
    const response = await axios.post(`${API_URL}/auth/verify-otp`, JSON.stringify({ userId, otp }), { headers: { 'Content-Type': 'application/json',
      role: 'admin'

     } });
    return response.data;
  },
  verifyUser: async (userId) => {
    const response = await axios.post(`${API_URL}/auth/verifyadmin-otp`, { userId },config);
    return response.data;
},
  fetchUserDetails: async (id) => {
    const response = await axios.get(`${API_URL}/auth/${id}`,config);
    return response?.data;
  },
  deposit: (userId, amount, adminId,subcategory,num) => {
    return axios.post(`${Api}/api/v1/walletcontroller/deposit`, { userId, amount, adminId,subcategory },{
      headers: {
          // Authorization: `Bearer ${Cookies.get('token')}`,
          role: 'admin',
          dashboard:num? 1 : 0
      },
    });
  },
  withdraw: (userId, amount, adminId) => {
    return axios.post(`${Api}/api/v1/walletcontroller/withdraw`, { userId, amount, adminId },config);
  },
  fetchUsers: async ({ page, limit, filter }) => {
    const params = { page, limit };
    if (filter) {
      const [key, value] = filter.split('=');
      params[key] = value;
    }
    const response = await axios.get(`${API_URL}/auth/get`, { params },config);
    return response.data;
  },
  blockUser: async ({ userId, status }) => {
    const response = await axios.patch(`${API_URL}/auth/${userId}/block`, { status },config);
    return response.data;
  },
  approveUser: async (userId) => {
    const response = await axios.patch(`${API_URL}/auth/${userId}/approve`,config);
    return response.data;
  },
  updateUser: async (userData) => {
    console.log(userData)
    const formData = new FormData();
    for (const key in userData) {
      if (key === 'idImage' && userData[key]) {
        formData.append(key, userData[key][0]); // Append the file object if exists
      } else {
        formData.append(key, userData[key]);
      }
    }
    const response = await axios.put(`${API_URL}/auth/update-profile/${userData.userId}`, userData?.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        role: 'admin'

      },
    });
    console.log(response.data);
    return response.data;
  },



  deleteUser: async (userId) => {
    const response = await axios.delete(`${API_URL}/auth/deleted/${userId}`,config);
    return response.data;
  },
};

export default UserService;
